import { MapPin } from "lucide-react";

const REGIONS = [
  {
    code: "NJ",
    name: "New Jersey",
    blurb:
      "Proudly serving communities across New Jersey — our primary service area.",
  },
  {
    code: "PA",
    name: "Pennsylvania",
    blurb:
      "Surrounding Pennsylvania areas, including Philadelphia and nearby neighborhoods.",
  },
  {
    code: "NY",
    name: "New York",
    blurb:
      "New York communities near Staten Island and the surrounding region.",
  },
];

export default function AreasWeServe() {
  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="relative bg-brand-navy-deep text-white overflow-hidden"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, #ffffff 1px, transparent 0)",
          backgroundSize: "28px 28px",
        }}
        aria-hidden="true"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.22em] text-amber-300 flex items-center gap-2 mb-5">
              <span className="h-px w-8 bg-amber-400" /> Areas We Serve
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1]">
              Proudly serving New Jersey, Pennsylvania, and nearby
              New York communities.
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-slate-300 leading-relaxed">
              Mobile healthcare support across New Jersey, surrounding
              Pennsylvania areas including Philadelphia, and New York
              communities near Staten Island.
            </p>
          </div>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10"
          data-testid="areas-grid"
        >
          {REGIONS.map((r) => (
            <article
              key={r.code}
              data-testid={`area-card-${r.code.toLowerCase()}`}
              className="bg-brand-navy-deep p-8 md:p-10 flex flex-col gap-4 border border-white/0 hover:border-amber-300/40 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-amber-300">
                  Region
                </span>
                <MapPin className="h-5 w-5 text-amber-300" />
              </div>
              <div className="font-heading text-5xl md:text-6xl font-semibold text-white tracking-tight">
                {r.code}
              </div>
              <div className="font-heading text-lg font-semibold text-white">
                {r.name}
              </div>
              <p className="text-slate-300 leading-relaxed text-sm">{r.blurb}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center text-slate-300 text-sm">
          Outside this area?{" "}
          <span className="text-white">Call us</span> — we coordinate select
          interstate transport and courier requests by appointment and
          availability.
        </div>
      </div>
    </section>
  );
}
